import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { AngularAppLogger } from "../../angular-app-logger";

@Injectable({
  providedIn: "root",
})
export class OrganizationService {
  constructor(
    readonly http: HttpClient,
    readonly appLogger: AngularAppLogger
  ) { }

  async fetchRawOrganizations(scopes:any): Promise<any[]> {
    const orgUrl = `${localStorage.getItem("cibmtr_url")}Organization?_security=`;
    if (scopes !== "") {
      try {
        const response: any = await this.http
          .get(`${orgUrl}${scopes}`)
          .toPromise();

        return response.entry?.map((orgEntry: any) => orgEntry.resource) || [];

      } catch (error) {
        this.handleError(error as HttpErrorResponse, orgUrl);
        throw error;
      }
    }

    const errorMessage =
      `your User ID has not been provisioned correctly. \n` +
      `Please contact the Service Desk at (763) 406-3411 or (800) 526-7809 x3411`;

    this.appLogger.logError(errorMessage, {
      context: "User id provisioning error",
      url: orgUrl
    });

    return [];
  }
  async fetchCenters(scopes: any): Promise<any[]> {
    const orgUrl = `${localStorage.getItem("cibmtr_url")}Organization?_security=`;

    const cibmtrCenters: any[] = [];
    if (scopes !== "") {
      await this.http
        .get(`${orgUrl}${scopes}`)
        .toPromise()
        .then((response: any) => {
          const orgEntries = response.entry;
          orgEntries.forEach((orgEntry: any) => {
            const value = "rc_" + orgEntry.resource.identifier[0].value;
            const name = orgEntry.resource.name;
            const telecom = orgEntry.resource.telecom;

            let telecomUrlItems = [];
            if (telecom) {
              telecomUrlItems = telecom.filter((item: any) => item.system === "url");
            }

            cibmtrCenters.push({
              value,
              name,
              selected: false,
              telecomUrlItems,
            });
          });
          this.appLogger.logInfo(`User logged in successfully and Org resource fetched`, { context: "Fetched Cibmtr centers"});
        })
        .catch((error) => {
          this.handleError(error, orgUrl);
        });
      return cibmtrCenters;
    }
    const errorMessage = `your User ID has not been provisioned correctly. \n Please contact the Service Desk at (763) 406-3411 or (800) 526-7809 x3411`;
    this.appLogger.logError(errorMessage, { context: 'User id provisioning error', url: orgUrl});
    return null as any;
  }

  validateSelectedOrg(selectedOrg: any) {
    if (selectedOrg.telecomUrlItems?.length > 0) {
      const recentOrgItem = selectedOrg.telecomUrlItems.filter(
        (item: any) => item.rank === 1
      );

      if (recentOrgItem[0]?.value !== localStorage.getItem("iss")) {
        const invalidIssuer = `The data submission was received from an unknown endpoint and cannot be processed: \n Issuer received : ${localStorage.getItem(
          "iss"
        )} \n \n Please open a ticket through NMDP ServiceNow and include the url listed above so that this can be addressed
        `;
        this.appLogger.showGlobalAlert(invalidIssuer, {context: `Invalid Organization`});
        throw Error(invalidIssuer);
      }
    }
  }

  handleErrorStr(error: string, url: string) {
    const errorMessage = `An unexpected error has occurred. Please report this to CIBMTR. \nMessage : ${error}.`;
    this.appLogger.logError(errorMessage, {context: 'Logging from handleErrorStr', url: url});
    return throwError(error);
  }

  handleError(error: HttpErrorResponse, url?: string) {
    const errorMessage = `An unexpected failure has occurred. Please try again. If the error persists, please report this to CIBMTR. Status: ${error.status
      } \n Message : ${error.error?.errorMessage || error.message}. \n`;
    console.log(errorMessage);
    this.appLogger.logError(errorMessage, {context: 'Logging from handleError', url: url});
    return throwError(error);
  }
}

